<template>
  <div
    ref="cBtn"
    v-ripple
    :class="[
      'c-button d-inline-flex align-center justify-center rounded-50',
      {
        'bg-orange white--text-abs':
          !isSecondary && !shouldDisabled && !isDefault,
        'is-secondary has-hover-effect primary--text':
          isSecondary && !shouldDisabled,
        'border-default': !!shouldDisabled || !!isDefault,
        'is-short': isShort,
        'is-narrow': isNarrow,
        'disabled gray--text': shouldDisabled,
        'is-small': isSmall,
      },
    ]"
    @click="click"
  >
    <div
      :class="['font-weight-medium', { 'text-5': isSmall, 'text-4': !isSmall }]"
    >
      <slot v-if="!loading" />
      <v-progress-circular
        v-else
        indeterminate
        size="18"
        width="2"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    isDefault: {
      type: Boolean,
      default: false,
    },
    isSecondary: {
      type: Boolean,
      default: false,
    },
    isShort: {
      type: Boolean,
      default: false,
    },
    isNarrow: {
      type: Boolean,
      default: false,
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
    to: {
      type: Object,
    },
    disabled: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
    },
    widthPersistent: {
      type: Boolean,
      default: true,
    },
    walletRequired: Boolean,
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "auth/isAuthenticated",
      walletSelected: "userWallets/walletSelected",
      currentProject: "projectConfig/latestProject",
    }),
    shouldDisabled() {
      if (!this.walletRequired) return this.disabled;
      if (!this.walletSelected?.address) return false;
      return this.disabled;
    },
  },
  methods: {
    click($event) {
      if (!this.checkWallet()) return;
      if (this.loading || this.disabled) return;
      if (this.to) {
        return this.$router.push(this.to);
      }
      this.$emit("click", $event);
    },
    checkWallet() {
      if (!this.walletRequired) return true;
      if (!this.isAuthenticated) {
        this.$store.dispatch("setAuthModal", {
          shouldShow: true,
          component: "GetStarted",
          width: "604",
          data: {
            ecosystem: this.currentProject?.ecosystem,
            project: this.currentProject?.name,
          }
        });
        return false;
      }
      if (!this.walletSelected?.address) {
        this.$store.dispatch("showSelectWalletModal", {
          ecosystem: this.currentProject?.ecosystem,
          project: this.currentProject?.name,
        });
        return false;
      }
      return true;
    },
  },
  mounted() {
    if (this.widthPersistent) {
      this.$nextTick(() => {
        if (!this.$refs.cBtn) return;
        this.$refs.cBtn.style.minWidth = this.$refs.cBtn.offsetWidth + 1 + "px";
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.c-button {
  height: 44px;
  padding-left: 28px;
  padding-right: 28px;
  &:not(.disabled) {
    cursor: pointer;
  }
  &.is-short {
    height: 36px;
  }
  &.is-narrow {
    padding-left: 16px;
    padding-right: 16px;
  }
  &.bg-orange {
    &:hover {
      background: rgba(246, 96, 51, 0.85);
    }
  }
  &.is-secondary {
    background: rgba(246, 96, 51, 0.1);
  }
  &.is-small {
    height: 28px;
    padding-left: 12px;
    padding-right: 12px;
  }
}
</style>
